import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UtilitiesService {

  private urlAPI = environment.API;
  private sendEmailContact = 'sendEmailContactUs';
  private sendEmailClaimSheet = 'sendEmailClaimSheet';

  arrayPrefixPhone: Array<any> = [
    {country: 'Afghanistan', prefix: '+93'},
    {country: 'Albania', prefix: '+355'},
    {country: 'Algeria', prefix: '+213'},
    {country: 'American Samoa', prefix: '+1 (684)'},
    {country: 'Andorra', prefix: '+376'},
    {country: 'Angola', prefix: '+244'},
    {country: 'Anguilla', prefix: '+1 (264)'},
    {country: 'Antigua and Barbuda', prefix: '+1 (268)'},
    {country: 'Argentina', prefix: '+54'},
    {country: 'Armenia', prefix: '+374'},
    {country: 'Aruba', prefix: '+297'},
    {country: 'Ascension', prefix: '+247'},
    {country: 'Australia', prefix: '+61'},
    {country: 'Australian Capital Territory', prefix: '+672'},
    {country: 'Austria', prefix: '+43'},
    {country: 'Azerbaijan', prefix: '+994'},
    {country: 'Bahamas, The', prefix: '+1 (242)'},
    {country: 'Bahrain', prefix: '+973'},
    {country: 'Bangladesh', prefix: '+880'},
    {country: 'Barbados', prefix: '+1 (246)'},
    {country: 'Belarus', prefix: '+375'},
    {country: 'Belgium', prefix: '+32'},
    {country: 'Belize', prefix: '+501'},
    {country: 'Benin', prefix: '+229'},
    {country: 'Bermuda', prefix: '+1 (441)'},
    {country: 'Bhutan', prefix: '+975'},
    {country: 'Bolivia', prefix: '+591'},
    {country: 'Bosnia and Herzegovina', prefix: '+387'},
    {country: 'Botswana', prefix: '+267'},
    {country: 'Brazil', prefix: '+55'},
    {country: 'British Virgin Islands', prefix: '+1 (284)'},
    {country: 'Brunei', prefix: '+673'},
    {country: 'Bulgaria', prefix: '+359'},
    {country: 'Burkina Faso', prefix: '+226'},
    {country: 'Burma', prefix: '+95'},
    {country: 'Burundi', prefix: '+257'},
    {country: 'Cambodia', prefix: '+855'},
    {country: 'Cameroon', prefix: '+237'},
    {country: 'Canada', prefix: '+1'},
    {country: 'Cape Verde', prefix: '+238'},
    {country: 'Cayman Islands', prefix: '+1 (345)'},
    {country: 'Central African Republic', prefix: '+236'},
    {country: 'Chad', prefix: '+235'},
    {country: 'Chile', prefix: '+56'},
    {country: 'China', prefix: '+86'},
    {country: 'Colombia', prefix: '+57'},
    {country: 'Comoros', prefix: '+269'},
    {country: 'Congo, Democratic Republic of the', prefix: '+243'},
    {country: 'Congo, Republic of the', prefix: '+242'},
    {country: 'Cook Islands', prefix: '+682'},
    {country: 'Costa Rica', prefix: '+506'},
    {country: 'Côte d’Ivoire', prefix: '+225'},
    {country: 'Croatia', prefix: '+385'},
    {country: 'Cuba', prefix: '+53'},
    {country: 'Cyprus', prefix: '+357'},
    {country: 'Czech Republic', prefix: '+420'},
    {country: 'Denmark', prefix: '+45'},
    {country: 'Diego Garcia', prefix: '+246'},
    {country: 'Djibouti', prefix: '+253'},
    {country: 'Dominica', prefix: '+1 (767)'},
    {country: 'Dominican Republic', prefix: '+1 (809/829)'},
    {country: 'Ecuador', prefix: '+593'},
    {country: 'Egypt', prefix: '+20'},
    {country: 'El Salvador', prefix: '+503'},
    {country: 'Equatorial Guinea', prefix: '+240'},
    {country: 'Eritrea', prefix: '+291'},
    {country: 'Estonia', prefix: '+372'},
    {country: 'Ethiopia', prefix: '+251'},
    {country: 'Falkland Islands (Islas Malvinas)', prefix: '+500'},
    {country: 'Faroe Islands', prefix: '+298'},
    {country: 'Fiji', prefix: '+679'},
    {country: 'Finland', prefix: '+358'},
    {country: 'France', prefix: '+33'},
    {country: 'French Departments and Territories in the Indian Ocean', prefix: '+262'},
    {country: 'French Guiana', prefix: '+594'},
    {country: 'French Polynesia', prefix: '+689'},
    {country: 'Gabon', prefix: '+241'},
    {country: 'Gambia, The', prefix: '+220'},
    {country: 'Georgia', prefix: '+995'},
    {country: 'Germany', prefix: '+49'},
    {country: 'Ghana', prefix: '+233'},
    {country: 'Gibraltar', prefix: '+350'},
    {country: 'Global Mobile SatelliteSystem (GMSS), sharedcode', prefix: '+881'},
    {country: 'Greece', prefix: '+30'},
    {country: 'Greenland', prefix: '+299'},
    {country: 'Grenada', prefix: '+1 (473)'},
    {country: 'Group of countries, shared code', prefix: '+388'},
    {country: 'Guadeloupe', prefix: '+590'},
    {country: 'Guam', prefix: '+1 (671)'},
    {country: 'Guatemala', prefix: '+502'},
    {country: 'Guinea', prefix: '+224'},
    {country: 'Guinea-Bissau', prefix: '+245'},
    {country: 'Guyana', prefix: '+592'},
    {country: 'Haiti', prefix: '+509'},
    {country: 'Holy See (Vatican City)', prefix: '+379'},
    {country: 'Holy See (Vatican City)', prefix: '+39'},
    {country: 'Honduras', prefix: '+504'},
    {country: 'Hong Kong', prefix: '+852'},
    {country: 'Hungary', prefix: '+36'},
    {country: 'Iceland', prefix: '+354'},
    {country: 'India', prefix: '+91'},
    {country: 'Indonesia', prefix: '+62'},
    {country: 'Inmarsat SNAC', prefix: '+870'},
    {country: 'International Freephone Service', prefix: '+800'},
    {country: 'International Networks, shared code', prefix: '+882'},
    {country: 'International Networks, shared code', prefix: '+883'},
    {country: 'International Premium Rate Service (IPRS)', prefix: '+979'},
    {country: 'International Shared Cost Service (ISCS)', prefix: '+808'},
    {country: 'Iran', prefix: '+98'},
    {country: 'Iraq', prefix: '+964'},
    {country: 'Ireland', prefix: '+353'},
    {country: 'Israel', prefix: '+972'},
    {country: 'Italy', prefix: '+39'},
    {country: 'Jamaica', prefix: '+1 (876)'},
    {country: 'Japan', prefix: '+81'},
    {country: 'Jordan', prefix: '+962'},
    {country: 'Kazakhstan', prefix: '+7'},
    {country: 'Kenya', prefix: '+254'},
    {country: 'Kiribati', prefix: '+686'},
    {country: 'Korea, North', prefix: '+850'},
    {country: 'Korea, South', prefix: '+82'},
    {country: 'Kuwait', prefix: '+965'},
    {country: 'Kyrgyzstan', prefix: '+996'},
    {country: 'Laos', prefix: '+856'},
    {country: 'Latvia', prefix: '+371'},
    {country: 'Lebanon', prefix: '+961'},
    {country: 'Lesotho', prefix: '+266'},
    {country: 'Liberia', prefix: '+231'},
    {country: 'Libya', prefix: '+218'},
    {country: 'Liechtenstein', prefix: '+423'},
    {country: 'Lithuania', prefix: '+370'},
    {country: 'Luxembourg', prefix: '+352'},
    {country: 'Macau', prefix: '+853'},
    {country: 'Macedonia [FYROM]', prefix: '+389'},
    {country: 'Madagascar', prefix: '+261'},
    {country: 'Malawi', prefix: '+265'},
    {country: 'Malaysia', prefix: '+60'},
    {country: 'Maldives', prefix: '+960'},
    {country: 'Mali', prefix: '+223'},
    {country: 'Malta', prefix: '+356'},
    {country: 'Marshall Islands', prefix: '+692'},
    {country: 'Martinique', prefix: '+596'},
    {country: 'Mauritania', prefix: '+222'},
    {country: 'Mauritius', prefix: '+230'},
    {country: 'Mayotte', prefix: '+269'},
    {country: 'Mexico', prefix: '+52'},
    {country: 'Micronesia, Federated States of', prefix: '+691'},
    {country: 'Moldova', prefix: '+373'},
    {country: 'Monaco', prefix: '+377'},
    {country: 'Mongolia', prefix: '+976'},
    {country: 'Montenegro', prefix: '+382'},
    {country: 'Montserrat', prefix: '+1 (664)'},
    {country: 'Morocco', prefix: '+212'},
    {country: 'Mozambique', prefix: '+258'},
    {country: 'Namibia', prefix: '+264'},
    {country: 'Nauru', prefix: '+674'},
    {country: 'Nepal', prefix: '+977'},
    {country: 'Netherlands', prefix: '+31'},
    {country: 'Netherlands Antilles', prefix: '+599'},
    {country: 'New Caledonia', prefix: '+687'},
    {country: 'New Zealand', prefix: '+64'},
    {country: 'Nicaragua', prefix: '+505'},
    {country: 'Niger', prefix: '+227'},
    {country: 'Nigeria', prefix: '+234'},
    {country: 'Niue', prefix: '+683'},
    {country: 'Northern Territory', prefix: '+1 (670)'},
    {country: 'Norway', prefix: '+47'},
    {country: 'Oman', prefix: '+968'},
    {country: 'Pakistan', prefix: '+92'},
    {country: 'Palau', prefix: '+680'},
    {country: 'Panama', prefix: '+507'},
    {country: 'Papua New Guinea', prefix: '+675'},
    {country: 'Paraguay', prefix: '+595'},
    {country: 'Peru', prefix: '+51'},
    {country: 'Philippines', prefix: '+63'},
    {country: 'Poland', prefix: '+48'},
    {country: 'Portugal', prefix: '+351'},
    {country: 'Puerto Rico', prefix: '+1 (787/939)'},
    {country: 'Qatar', prefix: '+974'},
    {country: 'Reserved', prefix: '+970'},
    {country: 'Romania', prefix: '+40'},
    {country: 'Russia', prefix: '+7'},
    {country: 'Rwanda', prefix: '+250'},
    {country: 'Saint Helena', prefix: '+290'},
    {country: 'Saint Kitts and Nevis', prefix: '+1 (869)'},
    {country: 'Saint Lucia', prefix: '+1 (758)'},
    {country: 'Saint Pierre and Miquelon', prefix: '+508'},
    {country: 'Saint Vincent and the Grenadines', prefix: '+1 (784)'},
    {country: 'Samoa', prefix: '+685'},
    {country: 'San Marino', prefix: '+378'},
    {country: 'Sao Tome and Principe', prefix: '+239'},
    {country: 'Saudi Arabia', prefix: '+966'},
    {country: 'Senegal', prefix: '+221'},
    {country: 'Serbia', prefix: '+381'},
    {country: 'Seychelles', prefix: '+248'},
    {country: 'Sierra Leone', prefix: '+232'},
    {country: 'Singapore', prefix: '+65'},
    {country: 'Slovakia', prefix: '+421'},
    {country: 'Slovenia', prefix: '+386'},
    {country: 'Solomon Islands', prefix: '+677'},
    {country: 'Somalia', prefix: '+252'},
    {country: 'South Africa', prefix: '+27'},
    {country: 'Spain', prefix: '+34'},
    {country: 'Sri Lanka', prefix: '+94'},
    {country: 'Sudan', prefix: '+249'},
    {country: 'Suriname', prefix: '+597'},
    {country: 'Swaziland', prefix: '+268'},
    {country: 'Sweden', prefix: '+46'},
    {country: 'Switzerland', prefix: '+41'},
    {country: 'Syria', prefix: '+963'},
    {country: 'Taiwan', prefix: '+886'},
    {country: 'Tajikistan', prefix: '+992'},
    {country: 'Tanzania', prefix: '+255'},
    {country: 'Telecommunications for Disaster Relief (TDR)', prefix: '+888'},
    {country: 'Thailand', prefix: '+66'},
    {country: 'Timor-Leste', prefix: '+670'},
    {country: 'Togo', prefix: '+228'},
    {country: 'Tokelau', prefix: '+690'},
    {country: 'Tonga', prefix: '+676'},
    {country: 'Trial of a proposed new international service, shared code', prefix: '+991'},
    {country: 'Trinidad and Tobago', prefix: '+1 (868)'},
    {country: 'Tristan da Cunha', prefix: '+290'},
    {country: 'Tunisia', prefix: '+216'},
    {country: 'Turkey', prefix: '+90'},
    {country: 'Turkmenistan', prefix: '+993'},
    {country: 'Turks and Caicos Islands', prefix: '+1 (649)'},
    {country: 'Tuvalu', prefix: '+688'},
    {country: 'Uganda', prefix: '+256'},
    {country: 'Ukraine', prefix: '+380'},
    {country: 'United Arab Emirates', prefix: '+971'},
    {country: 'United Kingdom', prefix: '+44'},
    {country: 'United States', prefix: '+1'},
    {country: 'Universal Personal Telecommunication (UPT)', prefix: '+878'},
    {country: 'Uruguay', prefix: '+598'},
    {country: 'Uzbekistan', prefix: '+998'},
    {country: 'Vanuatu', prefix: '+678'},
    {country: 'Venezuela', prefix: '+58'},
    {country: 'Vietnam', prefix: '+84'},
    {country: 'Virgin Islands', prefix: '+1 (340)'},
    {country: 'Wallis and Futuna', prefix: '+681'},
    {country: 'Yemen', prefix: '+967'},
    {country: 'Zambia', prefix: '+260'},
    {country: 'Zimbabwe', prefix: '+263'}
];

  constructor(
    private http: HttpClient
  ) { }

  closeWindow() {
    window.close();
  }

  lowerCase(value: string): string {
    return value.toLowerCase();
  }

  /***
   * Send by email Claim Sheet
   */
  sendClaimSheetByEmail(data: any): Observable<any> {
    return this.http.post<any>(`${this.urlAPI}${this.sendEmailClaimSheet}`, {data});
  }

  /***
   * Send by email Contact-Us
   */
  sendContactUsByEmail(data: any): Observable<any> {
    return this.http.post<any>(`${this.urlAPI}${this.sendEmailContact}`, {data});
  }

  getPrefixPhone() {
    return this.arrayPrefixPhone;
  }

  getLink1xBet() {
    return 'https://affpa.top/L?tag=d_1840407m_97c_banner&site=1840407&ad=97';
  }

  getLinkAT() {
    return 'https://www.apuestatotal.com?utm_source=Social&utm_medium=FB/IG&utm_campaign=Tactica_Garraycorazon_Impression_2023_Sept&utm_content=PPL-garra-corazón-24/7_FullFormat_AP_Afinitty-InMarket_Intereses-AT-Branding';
  }

  getLinkM247() {
    return 'https://sorteos.marcadores247.com/';
  }

  getLinkOdebodog() {
    return 'https://www.bodog.com/es/sports?overlay=join&referral=Z_ofh9oEqfRj1rlaWl4naGNd7ZgqdRLk&affid=29411&utm_medium=&utm_source=29411&m_id=&b_id=1&referrer=www.marcadores247.com';
  }

  getLinkMelbet() {
    return 'https://refpaikgai.top/L?tag=d_2259469m_2170c_&site=2259469&ad=2170';
  }

  getLinkInkaBet() {
    return 'https://media.inkabet.pe/redirect.aspx?pid=8944308&bid=13422';
  }

  getLinkBetson() {
    return 'https://record.betsson.com/_Ti2A_Nhhq1LGafW5HX0s88Bp_3o02tqi/1/';
  }

  getFormAds() {
    return 'https://forms.gle/NnaGTZyGneudAei19';
  }

  getAfiliapago() {
    return 'https://app.afiliago.com/go/15778/3BVdmha6vg/2';
  }

  getBetAfair() {
    return 'https://app.afiliago.com/go/15779/UHTPj31fXK/2';
  }

  getPlayzonbet() {
    return 'https://tracker.playzonbet.com/link?btag=48484585_268943';
  }
  getGambeta() {
    return 'https://track.gambeta10.com/5/29';
  }

  getCountry(str:string|null):string {
    return str ? str : 'International'
  }
}
